import React from 'react';
import { Paper, PaperProps } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  container: {
    padding: 25,
  },
});

const Box: React.FC<PaperProps> = ({ children, ...other }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.container} variant="outlined" {...other}>
      {children}
    </Paper>
  );
};

export const TableBox = withStyles(() => ({
  root: {
    padding: 0,
    marginBottom: 40,
    width: '100%',
    overflowX: 'auto',
    borderBottom: 'none',
  },
}))(Box);

export default Box;
